import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordLinkExpiredPath = () => urlHelper(`/forgot-password/link-expired`);
export const getForgotPasswordPasswordChangedPath = () => urlHelper(`/forgot-password/password-changed`);
